<template>
  <button :class="classes" :disabled="disabled" type="submit" @click="$emit('click')" >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "ButtonComponent",
  props: {
    tailwind: {
      type: [String, Array],
      default: '',
    },
    disabled:{
      type:Boolean,
      default: Boolean,
    },
    classes:{
      type:[String,Object],
      default: '',
    }
  },
}
</script>

<style scoped>
button.green {
  @apply text-[14px] font-[600]  text-white flex justify-center gap-1 w-full p-3 bg-[#10ad86] border-green-5000 rounded-lg;
}
button.lightGreen {
  @apply text-[14px] font-[600]  text-white flex justify-center gap-1 w-full p-3 bg-green-300 border-green-5000 rounded-lg;
}
button.purple {
  @apply text-[14px] font-[600] text-white flex justify-center gap-1 p-3 bg-Primary6 rounded-lg;
}
button.purple-line {
  @apply text-[14px] font-[600] text-Primary6 flex justify-center gap-1 p-3 border border-Primary6 rounded-lg;
}
button.disable-mode {
  @apply text-[14px] font-[600] text-white flex justify-center gap-1 p-3 bg-[#D5D5D5] rounded-lg;
}

</style>